<template>
  <div>
    <div class="container">
      <img
        class="image"
        :src="diagram"
        alt="Safe Diagram"
      />
      <div class="mac-address">
        {{ macAddress.toUpperCase() }}
      </div>
    </div>
  </div>
</template>

<script>
import safeDiagram from '@/assets/safe_diagram.png'

export default {
  name: 'SafeImage',
  props: {
    macAddress: {
      type: String,
      default: 'a1:b2:c3:d4:e5:f6',
    },
  },
  data() {
    return {
      diagram: safeDiagram,
    }
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: fit-content;
  position: relative;
  margin: auto;
}

.image {
  max-width: 100%;
  height: 300px;
  display: block;
  object-fit: contain;
}

.mac-address {
  position: absolute;
  top: 53%;
  left: 63.5%;
  transform: translate(-50%, -50%);
  color: $dark-grey;
  background-color: transparent;
  font-family: monospace;
  font-size: 0.6em;
  z-index: 10;
  min-width: 15 * 0.6em;
}
</style>
